<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="DIMENSIONES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row align-h="center" class="mb-2">
              <div id="pa-dimensions">
                <div class="diagram-container">
                  <img :src="dimensionsImg" alt="dimensions-img">

                  <div class="input dim_a">
                    <ValidationProvider rules="min_value:0" v-slot="{ valid, errors }">
                      <b-input
                        v-model="form.dim_a"
                        size="sm"
                        :state="errors[0] ? false : null"
                        :class="{ 'border-success': valid && form.dim_a }"
                        class="diagram-input"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input dim_b">
                    <ValidationProvider rules="min_value:0" v-slot="{ valid, errors }">
                      <b-input
                        v-model="form.dim_b"
                        size="sm"
                        :state="errors[0] ? false : null"
                        :class="{ 'border-success': valid && form.dim_b }"
                        class="diagram-input"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input dim_c">
                    <ValidationProvider rules="min_value:0" v-slot="{ valid, errors }">
                      <b-input
                        v-model="form.dim_c"
                        size="sm"
                        :state="errors[0] ? false : null"
                        :class="{ 'border-success': valid && form.dim_c }"
                        class="diagram-input"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input dim_d">
                    <ValidationProvider rules="min_value:0" v-slot="{ valid, errors }">
                      <b-input
                        v-model="form.dim_d"
                        size="sm"
                        :state="errors[0] ? false : null"
                        :class="{ 'border-success': valid && form.dim_d }"
                        class="diagram-input"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input dim_e">
                    <ValidationProvider rules="min_value:0" v-slot="{ valid, errors }">
                      <b-input
                        v-model="form.dim_e"
                        size="sm"
                        :state="errors[0] ? false : null"
                        :class="{ 'border-success': valid && form.dim_e }"
                        class="diagram-input"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="input dim_f">
                    <ValidationProvider rules="min_value:0" v-slot="{ valid, errors }">
                      <b-input
                        v-model="form.dim_f"
                        size="sm"
                        :state="errors[0] ? false : null"
                        :class="{ 'border-success': valid && form.dim_f, 'border-danger': !validDimF }"
                        class="diagram-input"
                      />
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row align-h="center" class="mb-2">
              <p class="medidas">*Medidas en centímetros*</p>
            </b-row>
            <b-row class="mb-4">
              <b-col cols="12" md="5" class="pl-0 pl-md-1">
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <Label label="Medida con piso terminado" />
                  </template>
                  <b-radio-group size="lg" v-model="form.floor_finished" class="ml-4">
                    <b-radio :value="true">
                      Sí
                    </b-radio>
                    <b-radio :value="false">
                      No
                    </b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
              <b-col class="pl-0" v-if="!form.floor_finished">
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <Label label="Altura de piso a restar" :blank="form.floor_height" />
                  </template>
                  <ValidationProvider :rules="{ required: true, min_value: 0}" name="Detalle" style="width: 100%" v-slot="{ valid, errors }">
                    <b-input-group append="cm" style="width: 300px;">
                      <b-form-input
                        v-model.number="form.floor_height"
                        :state="errors[0] ? false : (valid ? true : false)"
                        type="number"
                        min="0"
                        step="1"
                      />
                    </b-input-group>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Tipo de superficie de montaje" :blank="form.mounting_surface" show-reset @reset="form.mounting_surface = null" />
                </template>
                <b-select v-model="form.mounting_surface" :options="mountingSurfaceOptions">
                  <template #first>
                    <b-select-option v-show="!form.mounting_surface" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>
            <b-row v-if="form.mounting_surface === 'Otro'" class="mb-4">
              <ValidationProvider :rules="{ required: form.mounting_surface_custom }" name="Detalle el tipo de superficie" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Detalle el tipo de superficie" :blank="form.mounting_surface_custom" />
                  </template>
                  <b-textarea v-model="form.mounting_surface_custom" rows="3" trim :state="errors[0] ? false : (valid ? true : false)" />
                </b-form-group>
              </ValidationProvider>
            </b-row>
            <b-row class="flex-column mb-1">
              <Label label="¿Se evidencia desnivel o descuadre en el buque?" :blank="form.floor_type" show-reset @reset="form.floor_type = null" />
              <b-form-group>
                <b-radio-group size="lg" v-model="form.floor_type" stacked class="ml-4">
                  <b-radio value="No">
                    No
                  </b-radio>
                  <b-radio value="Si">
                    Si
                  </b-radio>
                  <b-radio value="requiero asistencia">
                    Requiero asistencia para determinar
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>
            <b-row v-if="['Si', 'requiero asistencia'].includes(form.floor_type)" class="mb-4">
              <ValidationProvider :rules="{ required: form.floor_type_details }" name="Detalle" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Detalle el problema con el desnivel" :blank="form.floor_type_details" show-reset @reset="form.floor_type_details = ''" />
                  </template>
                  <b-textarea v-model="form.floor_type_details" rows="3" trim :state="errors[0] ? false : (valid ? true : false)" />
                </b-form-group>
              </ValidationProvider>
            </b-row>

            <StepNotes
              :value="form.dimensions_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mountingSurfaceOptions } from '../../../../sharedOptions/puertasAutomaticasModule'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'
import DimensionsImage from '../../../../../assets/images/puerta_automatica/dimensions.png'
import StepNotes from '../StepNotes'

export default {
  name: 'Dimensions',
  components: { Label, ConfiguratorStepTitle, ValidationObserver, ValidationProvider, StepNotes },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        dim_a: null,
        dim_b: null,
        dim_c: null,
        dim_d: null,
        dim_e: null,
        dim_f: null,
        mounting_surface: null,
        mounting_surface_custom: null,
        floor_type: null,
        floor_type_details: null,
        floor_finished: false,
        floor_height: 0.0,
        dimensions_notes: ''
      },
      mountingSurfaceOptions: mountingSurfaceOptions,
      dimensionsImg: DimensionsImage
    }
  },
  mounted () {
    if (this.puerta) {
      this.form.dim_a = this.puerta.dim_a
      this.form.dim_b = this.puerta.dim_b
      this.form.dim_c = this.puerta.dim_c
      this.form.dim_d = this.puerta.dim_d
      this.form.dim_e = this.puerta.dim_e
      this.form.dim_f = this.puerta.dim_f
      this.form.mounting_surface = this.puerta.mounting_surface
      this.form.mounting_surface_custom = this.puerta.mounting_surface_custom
      this.form.floor_type = this.puerta.floor_type
      this.form.floor_type_details = this.puerta.floor_type_details
      this.form.floor_finished = this.puerta.floor_finished
      this.form.floor_height = this.puerta.floor_height
      this.form.dimensions_notes = this.puerta.dimensions_notes
    }
  },
  computed: {
    ...mapState({
      puerta: state => state.configurator.configurable
    }),
    ...mapGetters(['configuratorStepNumber']),
    validDimF () {
      if (this.form.dim_b > 0 && this.form.dim_c > 0 && this.form.dim_f > 0) {
        return Number(this.form.dim_b ) + Number(this.form.dim_c) === Number(this.form.dim_f)
      }

      return true
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const newForm = Object.assign({}, this.form)
      if (!newForm.floor_height || newForm.floor_finished) {
        newForm.floor_height = 0
        this.form.floor_height = 0
      }

      const result = await this.updateConfigurable(newForm)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.puerta[key])
    },
    updateStepNotes (notes) {
      this.form.dimensions_notes = notes
    }
  }
}
</script>

<style scoped lang="scss">
  #pa-dimensions {
    display: flex;
    justify-content: center;
    align-items: center;

    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 720px;
        width: 100%;
        height: auto;
        align-self: center;
      }
    }

    .input {
      position: absolute;
    }

    .dim_a { top: 30%; left: 48.4%; }
    .dim_b { top: 48.4%; left: 49%; }
    .dim_c { top: 9.4%;  left: 49%; }
    .dim_d { top: 42%; left: 20%; }
    .dim_e { top: 42%; right: 21%; }
    .dim_f { top: 34%; left: 0%; }
  }


  @media (max-width: 768px) {
    #pa-dimensions {
      .diagram-container {
        img {
          width: 100%;
          height: auto;
        }
      }

      .dim_a { top: 26%; left: 47.4%; }
      .dim_b { top: 46.4%; left: 49%; }
      .dim_c { top: 7.4%;  left: 49%; }
      .dim_d { top: 42%; left: 18%; }
      .dim_e { top: 42%; right: 18%; }
      .dim_f { top: 32%; left: -5%; }
    }
  }
</style>
